import type {
    CatalogueJewelleriesBraceletsFilterInput,
    CatalogueJewelleriesEarringsFilterInput,
    CatalogueJewelleriesFilterInput,
    CatalogueJewelleriesNecklacesFilterInput,
    CatalogueJewelleriesRingsFilterInput,
} from '@/graphql/api'

export function clearMultiMetal<
    T extends
        | CatalogueJewelleriesBraceletsFilterInput
        | CatalogueJewelleriesNecklacesFilterInput
        | CatalogueJewelleriesEarringsFilterInput
        | CatalogueJewelleriesRingsFilterInput
        | CatalogueJewelleriesFilterInput,
>(filters: T): T {
    return {
        ...filters,
        primaryMetalCodes:
            filters.primaryMetalCodes && filters.primaryMetalCodes?.length > 1
                ? []
                : filters.primaryMetalCodes,
    }
}
